
import apiWorker from '../apiWorker'

const load = {
    standard : () => apiWorker('get', `/v1/load/standard`),
}

export default load;